import React from 'react';
import RuleTestsHeader from './components/RuleTestsHeader';
import ManageRuleTestsTable from './components/ManageRuleTestsTable/ManageRuleTestsTable';

import appStyles from '../Routes.css';

const RuleTests = () => {
    return (
        <div className={appStyles.landingPage}>
            <RuleTestsHeader />
            <ManageRuleTestsTable showKebabMenuCol hideCompareCol />
        </div>
    );
};

export default RuleTests;
